<template>
  <div>
    <div class="action">
      <Row
        class-name="btn"
        type="flex"
        justify="center"
        v-if="processing && params.row.btnConfirm">
        <span
          @click="handleBalanceConfirm(params.row)">
         {{ mlang('balanceConfirm') }}
        </span>
      </Row>
      <Row
        class-name="btn"
        type="flex"
        justify="center"
        v-if="processing && params.row.btnDisConfirm">
        <span
          @click="handleBalanceCancelConfirm(params.row)">
         {{ mlang('balanceCancelConfirm') }}
        </span>
      </Row>
      <Row
        class-name="btn"
        type="flex"
        justify="center"
        v-if="invoiced">
        <span
          @click="viewElectronicinvoices(params.row)">
         {{ mlang('viewElectronicinvoices') }}
        </span>
      </Row>
    </div>
  </div>
</template>

<script>
import Emitter from '@/u-components/mixins/emitter';
import CellMixin from '@/mixin/cellControl.js';
import InvoiceListProcessMixin from '@/mixin/invocieListProcess.js';
import ArchiveListMixin from '@/mixin/archive-list.js';
import { balanceConfirm, balanceCancelConfirm} from '@/api/myInvoices/invoices.js'
export default {
  name: 'InvoiceListProcessingAction',
  components: {},
  mixins: [Emitter, CellMixin, InvoiceListProcessMixin, ArchiveListMixin],
  data: function() {
    return {
      processing: this.$route.name === 'processing',
      invoiced: this.$route.name === 'invoiced'
    };
  },

  methods: {
    // 查看电子发票了
    viewElectronicinvoices(params) {
      window.open(params.einvoiceDownUrl, '_blank');
    },
    // 结算确认
    handleBalanceConfirm(params) {
      console.log("params: ", params)
      balanceConfirm([params]).then(res => {
        this.mixin_handleModal('balanceConfirmSingle', res)
      }).catch(() => {

      });
    },
    // 取消结算确认
    handleBalanceCancelConfirm(params) {
      console.log('params: ', params);
      balanceCancelConfirm([params]).then(res => {
          this.mixin_handleModal('balanceCancelConfirmSingle', res)
        }).catch(() => {

        });
    }

  }
};
</script>
